import { For, Show } from "solid-js";

import { usePlayer } from "~/components/PlayerContext";
import styles from "~/components/player/SongHistory.module.scss";
import { timeAgo } from "~/utils/timeAgo";

export default function SongHistory() {
  const player = usePlayer();
  const recentSongs = () =>
    (player.metadata?.song_history.slice(1, 6) ?? []).reverse();

  return (
    <div class={styles.wrapper}>
      <h3>Músicas Recentes</h3>
      <Show when={recentSongs().length > 0} fallback="Nenhuma...">
        <ul>
          <For each={recentSongs()}>
            {(song) => (
              <li>
                <time dateTime={new Date(song.start_time).toISOString()}>
                  {timeAgo(song.start_time)}
                </time>
                {[song.album, song.artist, song.title]
                  .filter(Boolean)
                  .join(" - ")}
              </li>
            )}
          </For>
        </ul>
      </Show>
    </div>
  );
}
